"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypeIcon = NotificationTypeIcon;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var notifications_1 = require("../../constants/notifications");
function NotificationTypeIcon(props) {
    var type = props.type, isUnread = props.isUnread, size = props.size;
    var SIZE_CLASSES = {
        small: { circle: "h-8 w-8", icon: 16 },
        medium: { circle: "h-10 w-10", icon: 20 },
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex shrink-0 items-center justify-center rounded-full ".concat(SIZE_CLASSES[size].circle, " ").concat(isUnread ? "bg-primary-green text-white" : "bg-light-gray text-medium-gray"), children: (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: notifications_1.NOTIFICATION_TYPE_ICONS[type], fontSize: SIZE_CLASSES[size].icon }) }));
}
